<template>
    <div class="pages_content table">
        <el-container>
            <el-header>
                <breaDcrumb />
            </el-header>
            <el-main style="display: flex">
                <div>
                    <el-collapse-transition>
                        <div v-show="showCardNav">
                            <div class="search">
                                <span style="display: inline-block; margin-bottom: 10px">
                                    <span style="margin-right: 12px">工程名称</span>
                                    <el-input v-model="tableParams.engineeringName"
                                        style="width: 180px; min-width: 150px; max-width: 220px" clearable placeholder="请输入"
                                        @keyup.enter.native="gettableData()" />
                                </span>
                                <span style="display: inline-block; margin-bottom: 10px">
                                    <span style="margin-right: 12px">欠款管控等级</span>
                                    <el-select v-model="tableParams.debtControlLevelList"  style="width: 180px" multiple clearable>
                                        <el-option label="不管控" :value="0"></el-option>
                                        <el-option label="等级一" :value="1"></el-option>
                                        <el-option label="等级二" :value="2"></el-option>
                                        <el-option label="等级三" :value="3"></el-option>
                                        <el-option label="等级四" :value="4"></el-option>
                                    </el-select>
                                </span>
                                <el-button icon="el-icon-search" style="margin-left: 24px" size="medium" class="bottom_all"
                                    @click="gettableData()">查 询</el-button>
                            </div>
                        </div>
                    </el-collapse-transition>
                    <div class="hr"></div>
                    <div class="card">
                        <div class="card_nav">
                            <div>
                                <el-button v-if="approvalStatus == 0 || approvalStatus == 4" size="small" class="bottom_all"
                                    style="margin-left: 0" @click="examineApprove()">
                                    风控复审
                                </el-button>
                            </div>
                            <div>
                                <el-link :underline="false" @click="downLoad()">
                                    <span class="el-icon--left">
                                        <i class="iconfont iconicon_button_export1"></i>
                                    </span>
                                    导出
                                </el-link>
                            </div>
                        </div>
                        <div v-loading="tableLoading" class="card_info" :style="style">
                            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }"
                                border stripe style="width: 100%" :data="tableData" :height="screenHeight - 425"
                                tooltip-effect="dark">
                                <template v-for="(item, index2) in table">
                                    <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                                        :width="item.width" :fixed="item.fixed">
                                        <template slot-scope="scope">
                                            <span v-if="item.label == '是否风控'">
                                                <el-select v-model="scope.row.whetherControl"
                                                    :disabled="approvalStatus != 0 && approvalStatus != 4"
                                                    style="width: 180px" clearable
                                                    @change="e => updateControl(e, scope.row.id)">
                                                    <el-option label="是" :value="1"></el-option>
                                                    <el-option label="否" :value="0"></el-option>
                                                </el-select>
                                            </span>
                                            <span v-else-if="item.label == '偏差率X（%）'">
                                                {{ decimal.mul(scope.row.deviationRateX || 0, 100) + '%' }}
                                            </span>
                                            <span v-else-if="item.label == '本期项目产值(万元)'">
                                                {{ decimal.div(scope.row.currentProjectOutputValue*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期合同应收款(万元)'">
                                                {{ decimal.div(scope.row.currentContractReceivables*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期累计回款(万元)'">
                                                {{ decimal.div(scope.row.currentCumulativePaymentReceived*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期工程欠款(万元)'">
                                                {{ decimal.div(scope.row.currentEngineeringArrears*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '本期合同欠款(万元)'">
                                                {{ decimal.div(scope.row.currentContractArrears*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '上期合同应收款(万元)'">
                                                {{ decimal.div(scope.row.lastContractReceivables*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '实时累计回款(万元)'">
                                                {{ decimal.div(scope.row.realTimeCumulativeReal*1 || 0, 10000) }}
                                            </span>
                                            <span v-else-if="item.label == '欠款管控等级'">
                                                <span v-if="scope.row.debtControlLevel == 0">不管控</span>
                                                <span v-if="scope.row.debtControlLevel == 1">等级一</span>
                                                <span v-if="scope.row.debtControlLevel == 2">等级二</span>
                                                <span v-if="scope.row.debtControlLevel == 3">等级三</span>
                                                <span v-if="scope.row.debtControlLevel == 4">等级四</span>
                                            </span>
                                            <span v-else>{{ scope.row[item.prop] }}</span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                        </div>
                    </div>
                </div>
            </el-main>
            <div class="card_bottom">
                <div class="card_bottom_left">
                    <div class="top_page_totle">总共{{ total }}条</div>
                    <!-- <el-pagination :current-page.sync="tableParams.page" :page-size="tableParams.pageSize"
                        :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
                        :total="total" @size-change="sizeChange" @current-change="gettableData()"></el-pagination> -->
                </div>
                <div>
                    <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
                        @click="gettableData">刷新</el-button>
                </div>
            </div>
        </el-container>
    </div>
</template>
  
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { overdueSupplyDetailQueryPage2, updateControl, updateData, overdueSupplyDownload as Download } from "@/api/internetSales/supplyManagement.js";
export default {
    components: {
    },
    mixins: [mixin],
    data() {
        return {
            table: [
                { label: "日期", prop: "dataMouth", status: true, width: "80", fixed: "left", },
                { label: "财务编码", prop: "financialCode", status: true, width: "220", fixed: "left", },
                { label: "工程名称", prop: "engineeringName", status: true, width: "280", fixed: "left", },
                { label: "合同单位", prop: "contractUnit", status: true, width: "220" },
                { label: "施工进度", prop: "constructionProgress", status: true, width: "auto" },
                { label: "本期项目产值(万元)", prop: "currentProjectOutputValue", status: true, width: "100" },
                { label: "本期合同应收款(万元)", prop: "currentContractReceivables", status: true, width: "110" },
                { label: "本期累计回款(万元)", prop: "currentCumulativePaymentReceived", status: true, width: "100" },
                { label: "本期工程欠款(万元)", prop: "currentEngineeringArrears", status: true, width: "100" },
                { label: "本期合同欠款(万元)", prop: "currentContractArrears", status: true, width: "100" },
                { label: "上期合同应收款(万元)", prop: "lastContractReceivables", status: true, width: "100" },
                { label: "实时累计回款(万元)", prop: "realTimeCumulativeReal", status: true, width: "100" },
                { label: "偏差率X（%）", prop: "deviationRateX", status: true, width: "auto" },
                { label: "合同欠款绝对额Y", prop: "contractArrearsAbsValue", status: true, width: "auto" },
                { label: "欠款管控等级", prop: "debtControlLevel", status: true, width: "auto" },
                { label: "是否风控", prop: "whetherControl", status: true, width: "auto" },
            ],
            tableData: [],
            DownloadURL: Download,
            pagesType: 0,
            tableParams: {
                engineeringName: "",
                debtControlLevelList:[],
                reviewId: "",
            },
            approvalStatus: "",//欠供复审 审批状态
        };
    },
    watch: {
    },
    async created() {
        this.tableParams.reviewId = this.$route.query.id
        this.approvalStatus = this.$route.query.approvalStatus
        this.gettableData();
    },
    methods: {
        downLoad() {
            this.$Download(this.DownloadURL, this.tableParams);
        },
        gettableData() {
            overdueSupplyDetailQueryPage2(this.tableParams).then(res => {
                if (res.code == 1001) {
                    this.tableData = res.data
                    this.total = res.data.length
                }
            })
        },
        examineApprove() {
            updateData({ id: this.tableParams.reviewId }).then(res => {
                if (res.code == 1001) {
                    this.$router.push({
                        name: "overdueSupplyReviewApproval",
                        query: {
                            formData: JSON.stringify({ id: this.tableParams.reviewId, dataMouth: this.tableData[0].dataMouth }),
                            dataContent: JSON.stringify({ id: this.tableParams.reviewId, dataMouth: this.tableData[0].dataMouth }),
                            type: 1,
                        }
                    })
                }
            })

        },
        updateControl(whetherControl, id) {
            updateControl({ id: id, whetherControl: whetherControl })
        },
        sizeChange(value) {
            this.tableParams.pageSize = value;
            this.gettableData();
        },
        /*重置数据,此方法必须存在，并且方发只重置条件*/
        init() {
            this.tableParams = this.$options.data().tableParams
            this.gettableData();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.el-input,
.el-select {
    width: 240px;
}

.table_link {
    margin: 0 10px;
    color: $bg_color;
    cursor: pointer;
}

.table_link:hover {
    opacity: 0.8;
}

.textCss {
    display: flex;
    /* 核心1：开启Flex */
    align-items: center;
    text-align: center;
    /* 核心属性 */
}
</style>
  